import { GroupBase, StylesConfig } from 'react-select'

type HeaderOption = { label: string; value: number }

export const getSelectStyles = (
    width = '60px'
): StylesConfig<HeaderOption, false, GroupBase<HeaderOption>> => ({
    control: (base) => ({
        ...base,
        backgroundColor: 'hsl(var(--background-base))',
        border: 'none',
        boxShadow: '0px 0.5px 2px 0px hsl(var(--background-disabled))',
        minHeight: '0px',
        width: width,
        cursor: 'pointer',
    }),
    valueContainer: (base) => ({
        ...base,
        padding: '0px',
    }),
    singleValue: (base) => ({
        ...base,
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: 'bold',
        color: 'hsl(var(--text-title))',
    }),
    indicatorsContainer: (base) => ({
        ...base,
        display: 'none',
    }),
    menu: (base) => ({
        ...base,
        width: width === '60px' ? '80px' : '120px',
        maxHeight: '200px',
        color: 'hsl(var(--text-title))',
        backgroundColor: 'hsl(var(--background-base))',
    }),
    menuList: (base) => ({
        ...base,
        maxHeight: '200px',
        backgroundColor: 'hsl(var(--background-base))',
    }),
    option: (base, state) => ({
        ...base,
        fontSize: '12px',
        fontWeight: 'bold',
        padding: '4px 8px',
        backgroundColor: state.isSelected
            ? 'hsl(198, 77%, 76%, 30%)'
            : 'hsl(var(--background-base)',
        color: state.isSelected
            ? 'hsl(var(--text-title))'
            : 'hsl(var(--text-title))',
        '&:active, &:hover, &:focus': {
            outline: 'none',
            backgroundColor: `hsl(198, 77%, 76%, 30%)`,
        },
    }),
})
